import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in belgium.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'reserver-une-visite',
  'club-facilities': 'equipements-du-club',
  'club-treatments': 'club-treatments',
  'club-fitness': 'club-fitness',
  'creche': 'creche',
  'exercise-classes': 'cours-de-gym',
  'gym': 'salle-de-fitness',
  'sports': 'sports',
  'kids-classes': 'cours-pour-enfants',
  'children': 'enfants',
  'pools': 'piscines',
  'spa': 'spa',
  'tennis': 'tennis',
  'enquire-now': 'se-renseigner',
  'enquiry-form': 'se-renseigner',
  'family-and-kids': 'famille-et-enfants',
  'golf': 'golf',
  'join-now': 'sinscrire',
  'manage-your-tour': 'gerer-votre-visite',
  'membership-trial': 'abonnement-dessai',
  'relax-and-socialise': 'detendez-vous-et-faites-des-rencontres',
  'timetable': 'horaires',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'entraînement-particulier',
  'join': 'nous-rejoindre',
  // If this link is changed, we should:
  // - Update nginx OJ route handling
  // - Update MSS/Common in the backend
  // - Update the links stored in CC e.g. see DLLABS-10292 (or add an nginx redirect from the old route)
  'join-online': 'joindre-en-ligne',
  // TODO Redesign: Check over these translations
  'membership-type': 'type-dadhesion',
  'members': 'membres',
  'personal-details': 'informations-personnelles',
  'your-price': 'votre-tarif',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'se-renseigner',
  'memberships': 'adhesions',
  'terms-and-conditions': 'termes-et-conditions',
  'policy': 'politique',
  'gyms-in-brussels': 'gyms-a-bruxelles',
  'careers': 'carrieres',
  'digital-signature': 'signature-numerique',
  'young-adult': 'jeune-adulte',
  'family': 'famille',
};
